export const AUTH0_ROLES = {
  PORTAL_READ_ONLY: 'Portal Read Only',
  SUPER_USER: 'Super User',
  STANDVAST_ADMIN: 'Admin',
  FINANCIAL_DATA_ACCESS: 'Financial Data Access',
};

export const DEFAULT_ROLE = 'Standard User';
